<template >
    <section class="footer-wrapper"  style="    overflow: hidden;">  
        <footer>
            <div class="footer-icon-wrapper">
                <div class="footer-icon">
                    <img alt="one-agency-logo" src="../assets/icons/noncolored/one_agency_icon.svg">
                </div>
                <p>IT RECRUITMENT<br> SPEZIALISTEN</p>
            </div>
            <div class="footer-links">
                <a>ONE Agency </a>
                <a>/ Impressum /</a>
                <a> Datenschutz </a>
            </div>
            <div class="footer-copyrights">Oneagency. All Rights Reserved.</div>
        </footer>

        <p class="developed-by">
            Developed by: <span>Adits</span>
        </p> 
    </section>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped> 
    .footer-wrapper{
        background-color: #000000;
        color: #FFFFFF;
        padding: 15px 0;
    }

    footer{
        display: flex;
        align-items: center;
        justify-content: space-between; 
        width: 65%;
        margin: 0 auto;
    }

    .footer-icon-wrapper{
        display: flex;
        align-items: center;
        gap: 8px;

        p{
            font-size: 16px;
            color: #FF6F2F;
        }

        .footer-icon{
            width: 127px;
             
            img{
                width: 100%;
            }
        }
    }

    .footer-links{
        a{
            font-size: 15px;
        }
    }


    .footer-copyrights{ 
        font-size: 15px;
    }

    .developed-by{
        text-align: center;
        font-size: 15px;
        span{
            color: #EF5612;
        }
    }



/* 2304-1470 */
@media (min-width: 2304px) {
    .footer-icon-wrapper .footer-icon {
        width: 140px;
    }

    .footer-icon-wrapper p {
        font-size: 18px; 
    }

    .footer-links a, .developed-by, .footer-copyrights {
        font-size: 16px;
    }
}

/* imac retina */
/*2560-1440*/
@media (min-width: 2560px) {
    .footer-icon-wrapper .footer-icon {
        width: 160px;
    }

    .footer-icon-wrapper p {
        font-size: 20px; 
    }

    .footer-links a, .developed-by, .footer-copyrights {
        font-size: 18px;
    }
}

/* 2880-1670 */
@media(min-width: 2880px) {
    .footer-icon-wrapper .footer-icon {
        width: 180px;
    }

    .footer-icon-wrapper p {
        font-size: 22px; 
    }

    .footer-links a, .developed-by, .footer-copyrights {
        font-size: 20px;
    }
}
 

/*3200-1800*/
@media(min-width: 3200px) {
    .footer-icon-wrapper .footer-icon {
        width: 200px;
    }

    .footer-icon-wrapper p {
        font-size: 24px; 
    }

    .footer-links a, .developed-by, .footer-copyrights {
        font-size: 22px;
    }
}

 
/* 3840 x 2160 2049 (4K) */
@media(min-width:3840px){
    .footer-icon-wrapper .footer-icon {
        width: 250px;
    }

    .footer-icon-wrapper p {
        font-size: 28px; 
    }

    .footer-links a, .developed-by, .footer-copyrights {
        font-size: 26px;
    }
}


/*1536-864*/
@media(max-width:1536px) {
    footer { 
        width: 1100px;
    }
}

/* macbook pro/air */
/* 1440-900 */
@media(max-width:1440px) {
    .footer-icon-wrapper .footer-icon {
        width: 110px;
    }

    .footer-links a, .developed-by, .footer-copyrights {
        font-size: 14px; 
    } 
}
 

/* macbook air */
/* 1280-800 */
@media (max-width:1280px) {
    footer { 
        width: 1000px;
    }

    .footer-icon-wrapper .footer-icon {
        width: 100px;
    }
}


/* micro duo */
/*1114x705*/
@media(max-width:1114px) {
    footer { 
        width: 900px;
    }
}

/* 900x1600 */
@media(max-width: 900px) {
    footer { 
        width: 800px;
    }

    .footer-icon-wrapper .footer-icon {
        width: 80px;
    }

    .footer-icon-wrapper p {
        font-size: 14px;
    }

    .footer-links a, .developed-by, .footer-copyrights {
        font-size: 12px; 
    } 
}

 

/* ipad pro 2022 */
/*834-1136*/
@media(max-width: 834px) {
    footer { 
        width: 750px;
    }
}
  

/* galaxy tab 7 */
/* 800x1280 */
@media(max-width: 800px) {
    .footer-wrapper { 
        padding: 30px 0;
    }
 
    footer { 
        flex-direction: column; 
        gap: 35px;
        width: 100%;
    }

    .footer-copyrights{
        margin-bottom: 35px;
    }

    .footer-links a, .developed-by, .footer-copyrights {
        font-size: 14px; 
    } 
}
</style>